<template>
  <div>
    <sub-header bizCd="02"/>
    <div class="sub_visual sub12">
      <div class="container">
        <div class="sub_txt">
          <div class="tit">AI 국가공인 자격증(AICE) </div>
          <div class="comment">
            국내 최초 국가공인 AI 자격증<br class="mobile840hidden">
            AICE Associate입니다.<br>
            KT가 개발한 인공지능 활용능력 시험<br class="mobile840hidden">
            AICE는 당신의 AI 실무 역량을 증명합니다.
          </div>
        </div>
      </div>
    </div>
    <div class="contents aos-all">
      <div class="container">
        <div class="sec">
          <div class="sub_tit">AICE 자격증 이란?</div>
          <div class="con">
            <div class="txt line02">
              <strong>국내 최초 국가공인 AI 자격</strong><br>
              KT가 개발한 인공지능 활용능력 시험 AICE TOEIC이 영어 실력을 증명하듯,<br>
              AICE는 당신의 AI 실무 역량을 증명합니다.<br>
              비즈니스 현장에 AI를 적용할 수 있는 실질적 모델링 능력을 국가공인 자격으로<br>
              인정받을 수 있는 국내 유일 AI 시험입니다.
            </div>
            <div class="info-list">
              <div>
                <p class="label">해석</p>
                <p class="desc">빅데이터를 읽어 해석하고<br>다룰 수 있는 능력</p>
                <p class="title">다양한 데이터에 기반한 문항</p>
              </div>
              <div>
                <p class="label">활용</p>
                <p class="desc">인공지능을 상황에 맞게<br>똑똑하게 쓰는 능력</p>
                <p class="title">실질적인 AI 활용능력 평가</p>
              </div>
              <div>
                <p class="label">해결</p>
                <p class="desc">현실 문제를 인공지능으로<br>해결하는 기획 능력</p>
                <p class="title">실사례 기반 문제해결 역량 평가</p>
              </div>
            </div>
          </div>
        </div>
        <div class="sec">
          <div class="sub_tit">지금 준비해야 되는 이유!</div>
          <div class="con">
            <div class="txt line02">요즘 2030이 주목하는 AICE Associate 왜 지금 준비해야 할까요?</div>
            <div class="banner_wrapper">
              <div class="img_2depth">
                <div class="ba_img"><img src="//img.eduwill.net/resources/b2b/live/images/reason1.png" alt=""></div>
                <div class="ba_img"><img src="//img.eduwill.net/resources/b2b/live/images/reason2.png" alt=""></div>
              </div>
              <div class="img_2depth">
                <div class="ba_img"><img src="//img.eduwill.net/resources/b2b/live/images/reason3.png" alt=""></div>
                <div class="ba_img"><img src="//img.eduwill.net/resources/b2b/live/images/reason4.png" alt=""></div>
              </div>
            </div>
          </div>
        </div>
        <div class="sec">
          <div class="sub_tit">AICE 취득 혜택</div>
          <div class="con">
            <div class="txt line02">
              ・ KT그룹 등 주요 기업 채용 우대<br>
              ・ 청년 AI/DX 인재양성 프로그램 'KT AIVLE School' 선발 우대<br>
              ・ AICE 자격증 / 디지털 배지 발급 및 AICE Network 등록
            </div>
            <div class="benefit-list">
              <div><img src="//img.eduwill.net/resources/b2b/live/images/benefit1.png"></div>
              <div><img src="//img.eduwill.net/resources/b2b/live/images/benefit2.png"></div>
              <div><img src="//img.eduwill.net/resources/b2b/live/images/benefit3.png"></div>
              <div><img src="//img.eduwill.net/resources/b2b/live/images/benefit4.png"></div>
              <div><img src="//img.eduwill.net/resources/b2b/live/images/benefit5.png"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="float_counsel m_hidden">
      <div class="group-wrap">
        <div class="group">
          <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
          <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
          <div class="ico-hand"></div>
        </div>
      </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
      <a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
  </div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
  name: "MainAiEdu",
  components: {SubHeader},
  data() {
    return {}
  },

  computed: {
  },

  methods: {
    showCounsel(v) {
      eventBus.$emit("show-counsel", v);
    },
    closeCurriculum(v) {
      $('.curriculum_pop_' + v).bPopup().close();
    },
    showCurriculum(v) {
      $('.curriculum_pop_' + v).bPopup();
    }
  },

  created() {
  },
  beforeMount() {
  },
  mounted() {
    AOS.init({ easing: 'ease-in-out-sine' })

    $(".pa_slider_scroll").simplyScroll({
      customClass:'vert',
      speed: 5,
      pauseOnHover : true
    });
  },
}
</script>

<style scoped>

</style>